import "./HeaderComponent.scss";
import ChildCareIcon from "../../assets/icons/child_care.svg";
import UnitedIcon from "../../assets/icons/United.svg";
import ChevronDownIcon from "../../assets/icons/chevron-down.svg";
import MoreVertIcon from "../../assets/icons/more_vert.svg";
import UserImage from "../../assets/icons/smiling-brunette-girl-posing-with-coat 1.svg";
import {
  Avatar,
  Box,
  Grid2,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import AvatarIcon from "../../components/icon-components/AvatarIcon";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { LANGUAGES } from "../../constants/CommonConstant";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import CustomSpinner from "../../components/custom-spinner/CustomSpinner";
import { useMsal } from "@azure/msal-react";
import { adminAuthSliceActions } from "../../auth/admin-auth/AdminAuthSlice";
import {
  useGetAdminMasterDataApiQuery,
  useGetAdminRoleDescriptionQuery,
} from "./services/GetAdminMasterDataAPISlice";
import { adminMasterDataActions } from "./services/AdminMasterDataSlice";
import appLogo from "../../../src/assets/images/app-logo/app_logo.png";

const AdminHeaderComponent = () => {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();
  const accessToken =
    useAppSelector((state) => state.adminAuth.user?.accessToken) ?? null;
  const patientProfileId = useAppSelector(
    (state) => state.patientProfileDetails.patientProfileInfo.patientProfileId
  );
  const { i18n, t } = useTranslation();

  i18n.on("languageChanged", (lng) => {
    console.log("Language changed to:", lng);
  });

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(menuAnchorEl);

  const [selectedLanguage, setSelectedLanguage] = useState(LANGUAGES[0].label);

  const [showButton, setShowButton] = useState(true);

  const toggleButton = () => {
    setShowButton(!showButton);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuAnchorEl(null);
    setShowButton(!showButton);
  };

  const onChangeLang = (e: React.MouseEvent<HTMLElement>) => {
    const lang_code = (e.target as HTMLLIElement).dataset.value;
    const lang_label = (e.target as HTMLLIElement).innerText;
    if (lang_code) {
      i18n.changeLanguage(lang_code);
      // setSelectedLanguage(lang_label); // Update the selected language
    }
    setAnchorEl(null);
  };

  const handleLogOutClick = () => {
    dispatch(adminAuthSliceActions.clearUser());
    instance.logoutRedirect();
  };

  const {
    data: adminMasterDataApiData,
    isLoading: adminMasterDataApiLoading,
    error: adminMasterDataApiError,
  } = useGetAdminMasterDataApiQuery({ accessToken });

  const {
    data: adminRoleDescriptionData,
    isLoading: adminRoleLoading,
    error: adminRoleApiError,
  } = useGetAdminRoleDescriptionQuery({ accessToken });

  useEffect(() => {
    if (adminRoleDescriptionData && !adminRoleLoading && !adminRoleApiError) {
      const transformedArray = adminRoleDescriptionData?.adminRoleAccess.map(
        (item: any) => ({
          label: item.roleDisplayName,
          value: item.roleId,
          desc: item.longDescription,
        })
      );

      const userRoles = transformedArray;
      dispatch(adminMasterDataActions.setUserRoles(userRoles));
      dispatch(
        adminMasterDataActions.setAdminRoleDesciption(
          adminRoleDescriptionData?.adminRoleAccess
        )
      );
    }
  }, [adminRoleDescriptionData, adminRoleLoading, adminRoleApiError, dispatch]);
  useEffect(() => {
    if (
      adminMasterDataApiData &&
      !adminMasterDataApiLoading &&
      !adminMasterDataApiError
    ) {
      dispatch(
        adminMasterDataActions.setDisplayGroups(
          adminMasterDataApiData.masterData.displayGroups
        )
      );
      dispatch(
        adminMasterDataActions.setTaskTypes(
          adminMasterDataApiData.masterData.milestoneTypes
        )
      );
      dispatch(
        adminMasterDataActions.setCategoryWiseStatus(
          adminMasterDataApiData.masterData.categoryWiseStatus
        )
      );
      dispatch(
        adminMasterDataActions.setEducationalContentTypes(
          adminMasterDataApiData.masterData.educationalContentTypes
        )
      );
      dispatch(
        adminMasterDataActions.setOptReasons(
          adminMasterDataApiData.masterData.optReasons
        )
      );
      dispatch(
        adminMasterDataActions.setActiveLanguages(
          adminMasterDataApiData.masterData.activeLanguages
        )
      );
    }
  }, [
    adminMasterDataApiData,
    adminMasterDataApiLoading,
    adminMasterDataApiError,
    dispatch,
  ]);

  const isLoading = adminMasterDataApiLoading;
  if (isLoading) {
    return <CustomSpinner />;
  }
  return (
    <Box className="top-nav">
      <Grid2
        container
        justifyContent="space-between"
        flexDirection={{ xs: "row", sm: "row" }}
        size={12}
      >
        <Grid2
          alignItems="center"
          size={{ xs: 6, sm: 6, md: 5, lg: 5 }}
        >
         <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              pl: 2,
              height: 45,
            }}
          >
            <Box
              component="img"
              src={appLogo}
              alt="App Logo"
              sx={{
                height: "100%",
                width: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          </Box>
        </Grid2>
        <Grid2
          container
          justifyContent={{ xs: "flex-end", sm: "flex-end" }}
          alignItems="center"
          flexDirection={{ xs: "row", sm: "row" }}
          spacing={0.5}
          size={{ xs: 6, sm: 6, md: 7, lg: 7 }}
        >
          <Grid2
            container
            flexDirection="row"
            alignItems="center"
          >
            <Box
              display="flex"
              alignItems="center"
            >
              {/* <Typography variant="h6" className="customer">
                Last Login:{" "}
                {navigationInfoApiData?.navigatioBarInfo?.lastLoginDateTime
                  ? formatDateMonthDateYear(
                      navigationInfoApiData.navigatioBarInfo.lastLoginDateTime
                    )
                  : "NA"}
              </Typography> */}

              {/* Mobile Icon */}
              {/* <Typography display={{ xs: "inline", sm: "none" }}>
                <IconButton onClick={handleMenuClick} className="header-icons">
                  {showButton && <MenuIcon onClick={toggleButton} />}
                  {!showButton && <CloseIcon onClick={toggleButton} />}
                </IconButton>
              </Typography> */}
            </Box>
            {/* <Typography
              variant="h6"
              className="phone-number"
              display={{ xs: "none", sm: "none", md: "none", lg: "flex" }}
            >
              | Data refreshed on:{" "}
              {navigationInfoApiData?.navigatioBarInfo?.lastDataRefreshDate
                ? formatDateMonthDateYear(
                    navigationInfoApiData.navigatioBarInfo.lastDataRefreshDate
                  )
                : "NA"}
            </Typography> */}
          </Grid2>
          <Grid2
            container
            flexDirection="row"
            alignItems="center"
            sx={{ flexDirection: "row", alignItems: "center" }}
            display={{ xs: "none", sm: "flex" }}
          >
            {/* <Box sx={{ pl: "5px", pr: "5px" }}>
              <img src={UnitedIcon} alt="United Icon" />
            </Box> */}

            {/* <Typography
              variant="h6"
              className="language"
            >
              {selectedLanguage}
            </Typography>
            <IconButton onClick={handleClick}>
              <img
                src={ChevronDownIcon}
                alt="Chevron Down Icon"
              />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              {LANGUAGES.map(({ label, code }) => (
                <MenuItem
                  key={code}
                  disabled={code === "es"}
                  data-value={code}
                  onClick={onChangeLang}
                >
                  {label}
                </MenuItem>
              ))}
            </Menu> */}
          </Grid2>

          <Grid2
            container
            flexDirection="row"
            alignItems="center"
            sx={{ flexDirection: "row" }}
          >
            <Typography display={{ xs: "none", sm: "flex" }}>
              {/* <Avatar
                alt="Emily Johnson"
                src={UserImage}
                sx={{ width: 22.5, height: 22.5 }}
              /> */}
              {/* <AvatarIcon width="36" height="36" /> */}
            </Typography>

            {/* Desktop  Icon */}
            <Typography display={{ xs: "none", sm: "flex" }}>
              <IconButton onClick={handleMenuClick}>
                <img
                  src={MoreVertIcon}
                  alt="More Vert Icon"
                />
              </IconButton>
            </Typography>

            <Menu
              id="menu"
              anchorEl={menuAnchorEl}
              open={menuOpen}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "menu-button",
              }}
            >
              {/* Mobile version */}
              {/* <Typography
                display={{ xs: "flex", sm: "none" }}
                alignItems="center"
              > */}
              {/* <Box sx={{ padding: "6px", position: "relative", top: "3px" }}>
                  <img src={UnitedIcon} alt="United Icon" height="20px" />
                </Box> */}

              {/* <Typography
                  sx={{ padding: "8px" }}
                  alignItems="center"
                  className="language"
                >
                  {selectedLanguage}
                </Typography>
                <IconButton onClick={handleClick}>
                  <img src={ChevronDownIcon} alt="Chevron Down Icon" />
                </IconButton>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {LANGUAGES.map(({ label, code }) => (
                    <MenuItem
                      key={code}
                      disabled={code === "es"}
                      data-value={code}
                      onClick={onChangeLang}
                    >
                      {label}
                    </MenuItem>
                  ))}
                </Menu>
              </Typography> */}
              {/* Desktop & Mobile in both places  */}
              <MenuItem onClick={handleLogOutClick}>Log out</MenuItem>
            </Menu>
          </Grid2>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default AdminHeaderComponent;
